<template>
    <div>

        <v-btn small depressed fab class="mx-2" color="#FF5100" :disabled="disable" @click="$emit('click')">
            <v-icon class="white--text">get_app</v-icon>
        </v-btn>

        <span v-if="disable && !click" style="user-select: none">
            {{$t('saveImg')}}
        </span>
        <span v-else-if="!click" style="cursor: pointer" @click="$emit('click')">
            {{$t('saveImg')}}
        </span>
        <span v-else style="user-select: none;cursor: pointer" @click="routerPush(click)">
            {{$t('saveImg')}}
        </span>

    </div>
</template>

<script>
    export default {
        name: "SaveImg",
        props: ['disable','click'],
        methods: {
            routerPush(path) {
                this.$router.push(path);
            }
        }
    }
</script>

<style scoped>
    .morebtn-hover:hover {
        -webkit-animation: spin .4s linear;
    }
    .morebtn-hover {
        -webkit-animation: revertspin .4s linear;
    }

    @-webkit-keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(180deg);
        }
    }
    @-webkit-keyframes revertspin {
        from {
            transform:rotate(180deg);
        }
        to {
            transform:rotate(0deg);
        }
    }
</style>
